import { Reveal } from "./Motion";
import { PROCESS } from "../../content/site";

export const ProcessSteps = ({ steps = PROCESS, tone = "dark" }) => (
  <div className="grid gap-px overflow-hidden rounded-2xl border border-[#082619]/10 bg-[#082619]/10 sm:grid-cols-2 lg:grid-cols-4" data-testid="process-steps">
    {steps.map((s, i) => (
      <Reveal key={s.n} delay={i * 0.1} className={`${tone === "dark" ? "bg-[#F9F8F3]" : "bg-[#082619]"} p-8 md:p-10`}>
        <div className="flex items-center gap-3">
          <span className="font-mono text-sm text-[#3f8a0f]">{s.n}</span>
          <span className="h-px flex-1 bg-current opacity-20" />
          <span className="h-2 w-2 rotate-45 bg-[#74DC26]" />
        </div>
        <h3 className={`font-display mt-10 text-2xl font-medium ${tone === "dark" ? "text-[#082619]" : "text-[#F9F8F3]"}`}>{s.title}</h3>
        <p className={`mt-3 text-sm leading-relaxed ${tone === "dark" ? "text-[#4C6053]" : "text-[#B4C7BA]"}`}>{s.text}</p>
      </Reveal>
    ))}
  </div>
);
